import React from 'react';
import PropTypes from 'prop-types';
import { lowerCase } from 'lodash';

const OfferBlankState = ({ filter, fullHeight }) => (
  <div className={`${fullHeight ? 'grey-section-full' : ''} offer-nav`}>
    <div className='max-width-div-center'>
      <h1 className='_2nd-header-copy'>
        {filter && filter.listingType
          ? `There are no ${lowerCase(filter.listingType)} offers at this time.`
          : 'No offer results'}
      </h1>
      <div className='text-block-4-copy'>
        New offers are always coming. Check again soon!
      </div>
    </div>
  </div>
);

OfferBlankState.propTypes = {
  filter: PropTypes.object,
  fullHeight: PropTypes.bool,
};

OfferBlankState.defaultProps = {
  filter: null,
  fullHeight: true,
};

export default OfferBlankState;



// WEBPACK FOOTER //
// ./src/components/Dashboard/OfferBlankState.js